import React, { Component, Fragment } from 'react';
import { Col, Row, Label, Input, Button, FormGroup } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../i18next';

import InStoreTypesModal from './InStoreTypesModal';
import TimeTableScreen from '../../../common/operationHours/TimeTableScreen';
import { FRONT_END_URL } from '../../../../utils/Constants';

class InStoreTypesSection extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isAddTypeModalOpen: false,
            isEdit: false,
            selectedType: {},
            selectedTypeIndex: null
        }

        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal(isAddTypeModalOpen, isEdit, selectedType, selectedTypeIndex) {
        this.setState({
            ...this.state,
            isAddTypeModalOpen,
            isEdit,
            selectedType,
            selectedTypeIndex
        })
    }

    renderInStoreTypes() {
        let queryString = '?';

        if (this.props.restaurantId) {
            queryString += `restaurantId=${this.props.restaurantId}`;
        }

        if (this.props.theme) {
            queryString += `&theme=${this.props.theme}`;
        }

        if (this.props.primaryColor) {
            let color = this.props.primaryColor;
            if (this.props.primaryColor.startsWith('#')) {
                color = color.slice(1);
            }
            queryString += `&primaryColor=${color}`;
        }

        return this.props.types.map((type, i) => {
            return (
                <Fragment>
                    <Row key={type.id} style={{ margin: '0 0 30px 0', paddingBottom: 20, justifyContent: 'space-between', borderBottom: '1px solid rgb(222, 226, 230)' }}>
                        <FormGroup style={{ display: 'flex', width: '100%', padding: '0 0 0 16px' }}>
                            <Label sm={3} style={styles.typeLabel}>{i18n.t('screens:restaurantsMainContainer.inStoreTitle')}</Label>
                            <Col sm={9} style={{ padding: 0 }}>
                                <Input type="text" name="title" disabled
                                    placeholder={type.title}
                                    value={type.title}
                                />
                            </Col>
                            <div style={{ width: 40, padding: '0 16px', display: 'flex', alignSelf: 'center', justifyContent: 'center', marginBottom: 10, marginLeft: 30, color: '#0288D1', cursor: 'pointer' }}
                                onClick={() => this.toggleModal(true, true, type, i)}
                            >
                                {i18n.t('common:buttons.edit')}
                            </div>
                        </FormGroup>
                        <FormGroup style={{ display: 'flex', width: '100%', padding: '0 0 0 16px' }}>
                            <Label sm={3} style={styles.typeLabel} for='label'>{i18n.t('screens:restaurantsMainContainer.inStoreLabel')}</Label>
                            <Col sm={9} style={{ padding: 0 }}>
                                <Input type='text' name='label' disabled
                                    placeholder={type.label}
                                    value={type.label}
                                />
                            </Col>
                        </FormGroup>
                        {
                            type.id &&
                            <FormGroup style={{ display: 'flex', width: '100%', padding: '0 0 0 16px' }}>
                                <Label sm={3} style={styles.typeLabel}>{i18n.t('screens:restaurantsMainContainer.qrCodeLink')}</Label>
                                <Col sm={9} style={{ padding: 0 }}>
                                    <Input type="text"
                                        name="qrCodeLink"
                                        disabled
                                        placeholder={type.title}
                                        value={`${FRONT_END_URL}/${queryString}&typeId=${type.id}#/dine-pay`}
                                    />
                                </Col>
                            </FormGroup>
                        }
                        <FormGroup style={{ display: 'flex', width: '100%', padding: '0 0 0 16px' }}>
                            <Label sm={3} style={styles.typeLabel}>{i18n.t('screens:restaurantsMainContainer.defaultMenu')}</Label>
                            <Col sm={9} style={{ padding: 0 }}>
                                <Input type="text" name="defaultMenuDraftDTO" disabled
                                    placeholder={type.defaultMenuDraftDTO ? type.defaultMenuDraftDTO.name : ''}
                                    value={type.defaultMenuDraftDTO ? type.defaultMenuDraftDTO.name : ''}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup style={{ display: 'flex', width: '100%', padding: '0 0 0 16px' }}>
                            <Label sm={3} style={styles.typeLabel}>{i18n.t('screens:restaurantsMainContainer.preparationTime')}</Label>
                            <Col sm={9} style={{ padding: 0 }}>
                                <Input type="text" name="inStorePrepTime" disabled
                                    placeholder={`${type.inStorePrepTime}${i18n.t('screens:restaurantsMainContainer.minutes')}`}
                                    value={`${type.inStorePrepTime}${i18n.t('screens:restaurantsMainContainer.minutes')}`}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup style={{ display: 'flex', width: '100%', padding: '0 0 0 16px' }}>
                            <Label sm={3} style={styles.typeLabel}>{i18n.t('screens:restaurantsMainContainer.enableFutureOrders')}</Label>
                            <Input
                                type="checkbox"
                                name='enableFutureOrders'
                                id='enableFutureOrders'
                                style={styles.checkboxInput}
                                checked={type.futureOrderEnabled}
                                disabled
                            />
                        </FormGroup>
                        {
                            type.futureOrderEnabled &&
                            <Col sm={12} style={{ padding: '0px 10px' }}>
                                <fieldset disabled='disabled'>
                                    <TimeTableScreen
                                        timeSlotBased={this.props.timeSlotBased}
                                        preparationTimes={this.props.timeSlotBased ? type.timeSlots : type.preparationTimes}
                                        updatePrepTimes={() => { }}
                                        readOnly={true}
                                    />
                                </fieldset>
                            </Col>
                        }
                    </Row>
                </Fragment>
            );
        });

    }

    render() {
        const { containerStyle, headerStyle, headerTitle, rowStyler } = this.props.styles;

        return (
            <Fragment>
                <Col style={containerStyle}>
                    <Row>
                        <div style={headerStyle}>
                            <MaterialIcon icon="local_atm" size={20} color="#0288d1" />
                            <span style={headerTitle}>{i18n.t('screens:restaurantsMainContainer.inStoreTypes')}</span>
                        </div>
                    </Row>
                    <Row style={rowStyler}>
                        <Col sm={12} style={{ padding: 0 }}>
                            {
                                this.props.types && this.props.types.length > 0 ?
                                    <Row>
                                        <div style={{ width: 'calc(100% - 200px)' }}>
                                            {this.renderInStoreTypes()}
                                        </div>
                                        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', flexDirection: 'column', paddingRight: 15 }} >
                                            <Button color="primary" onClick={() => this.toggleModal(true, false, {})}>
                                                <MaterialIcon icon="add_circle_outline" color="#fff" size={20} />&nbsp;{i18n.t('screens:restaurantsMainContainer.addInStoreType')}
                                            </Button>
                                            {<p
                                                style={{ color: '#dc3545', fontSize: '80%', marginTop: 10 }}
                                                hidden={!this.props.isTypesChanged}>
                                                {i18n.t('common:validations.saveWarningMsg')}
                                            </p>}
                                        </div>
                                    </Row>
                                    : <Row>
                                        <div style={{ width: 'calc(100% - 200px)' }}>
                                            <p style={{ marginLeft: 16 }}>{i18n.t('screens:restaurantsMainContainer.noInStoreTypes')}</p>
                                        </div>
                                        <div style={{ width: '100%', display: 'flex', alignItems: 'flex-end', flexDirection: 'column', paddingRight: 30 }} >
                                            <Button color="primary" onClick={() => this.toggleModal(true, false, {})}>
                                                <MaterialIcon icon="add_circle_outline" color="#fff" size={20} />&nbsp;{i18n.t('screens:restaurantsMainContainer.addInStoreType')}
                                            </Button>
                                            <p
                                                style={{ color: '#dc3545', fontSize: '80%', marginTop: 10 }}
                                                hidden={!this.props.isTypesChanged}>
                                                {i18n.t('common:validations.saveWarningMsg')}
                                            </p>
                                        </div>
                                    </Row>
                            }
                        </Col>
                    </Row>
                </Col>
                {
                    this.state.isAddTypeModalOpen ?
                        <InStoreTypesModal
                            isOpen={this.state.isAddTypeModalOpen}
                            selectedType={this.state.selectedType}
                            selectedTypeIndex={this.state.selectedTypeIndex}
                            isEdit={this.state.isEdit}
                            toggle={this.toggleModal}
                            changeInStoreTypes={this.props.changeInStoreTypes}
                            menus={this.props.menus}
                            timeSlotBased={this.props.timeSlotBased}
                        /> : null
                }
            </Fragment>
        );
    }
}

export default InStoreTypesSection;

const styles = {
    typeLabel: {
        paddingRight: 0,
        paddingTop: 9,
        paddingLeft: 0
    },

    checkboxInput: {
        position: "relative",
        margin: '15px 0px 0px 0px'
    },
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/InStoreTypesSection.js